import Icon from '../components/Icon.vue'

Icon.register({
  'ruler-combined': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M160 288v41.4l-158.4 158.4c-0.7-2.6-1.6-5-1.6-7.8v-448c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v64h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v64h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56zM480 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-448c-2.8 0-5.2-0.9-7.8-1.6l158.4-158.4h41.4v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h64v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h64v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler-combined.js
// module id = 1852
// module chunks = 0